interface PollArgs<T> {
  fn: () => Promise<T>;
  validate: (result: T) => boolean;
  interval: number;
  maxAttempts?: number;
}

const poll = async <T>({ fn, validate, interval, maxAttempts }: PollArgs<T>): Promise<T> => {
  let attempts = 0;

  const executePoll = async (resolve, reject) => {
    const result = await fn();
    attempts++;

    if (validate(result)) {
      return resolve(result);
    } else if (maxAttempts && attempts === maxAttempts) {
      return reject(new Error('Exceeded max attempts'));
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };

  return new Promise<T>(executePoll);
};

export default poll;
